
export function getEntries<Key extends string, Value>(obj: { [key in Key]: Value }) {
    return Object.entries(obj) as [Key, Value][];
}

export type DeferredPromise<T> = [ Promise<T>, (value: (T | PromiseLike<T>)) => void, (reason?: any) => void ];
export function createDeferredPromise<T>(): DeferredPromise<T> {
    let resolve;
    let reject;
    const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
    });

    return [ promise, resolve!, reject! ];
}


export function createDelayPromise(delay: number): Promise<undefined>;
export function createDelayPromise<T>(delay: number, value?: T): Promise<T> {
    return new Promise((resolve) => setTimeout(() => resolve(value!), delay));
}